/**
 * 将嵌套对象扁平化为 dot-key 对象。
 * 例如 { common: { save: 'Save' } } => { 'common.save': 'Save' }
 */
export function flatten(obj: Record<string, unknown>, prefix = ''): Record<string, string> {
  const result: Record<string, string> = {}

  for (const key of Object.keys(obj)) {
    const value = obj[key]
    const newKey = prefix ? `${prefix}.${key}` : key

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flatten(value as Record<string, unknown>, newKey))
    } else if (typeof value === 'string') {
      result[newKey] = value
    }
  }

  return result
}
